import { css } from 'styled-components';

export const alertStyleDanger = css`
  color: #e9573d;
`;

export const alertStyleSuccess = css`
  color: #a1b637;
`;
